import { ref } from 'vue'

// One pager per record panel; a reset invalidates any response from the previous route.
export function usePagedRecords(fetchPage, pageSize = 10) {
  const records = ref([])
  const loading = ref(false)
  const error = ref('')
  const hasMore = ref(true)
  let page = 0
  let version = 0
  let source = ''

  function reset(nextSource = '') {
    version += 1
    source = nextSource
    page = 0
    records.value = []
    loading.value = false
    error.value = ''
    hasMore.value = Boolean(source)
  }

  async function loadMore() {
    if (!source || loading.value || !hasMore.value) return
    const requestVersion = version
    loading.value = true
    error.value = ''
    try {
      const result = await fetchPage(source, { pageNumber: page + 1, pageSize })
      if (requestVersion !== version) return
      const rows = result?.data || []
      const seen = new Set(records.value.map(record => String(record.id)))
      records.value = [...records.value, ...rows.filter(record => !seen.has(String(record.id)))]
      page += 1
      hasMore.value = rows.length > 0 && (result?.total != null
        ? page * pageSize < Number(result.total)
        : rows.length === pageSize)
    } catch (cause) {
      if (requestVersion === version) error.value = cause.message || '记录加载失败，请重试'
    } finally {
      if (requestVersion === version) loading.value = false
    }
  }

  return { records, loading, error, hasMore, reset, loadMore }
}
